import { Icon, Tooltip } from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  FaArrowAltCircleDown,
  FaArrowAltCircleUp,
  FaTrash,
} from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  createNewFolder,
  resetCardsSelection,
} from "../../../_actions/folderActions";
import { TldrConfirmationModal } from "../../common/statelessView";
import TldrMoveToFolderModal from "../../home/TldrMoveToFolderModal";
import { TldrCheckbox, TldrNewFolderDialog } from "./statelessView";
import { HomeSelectionRow } from "./stylesHome";

const TldrSelectedCardsRow = (props) => {
  const signal = axios.CancelToken.source();

  const {
    removeFromFolder,
    classes,
    displayNamePluralForm,
    type,
    displayType,
    marginTop,
    marginBottom,
    onDeleteSelected,
    onMoveToFolder,
    onRemoveFromFolder,
    currentFolderId,
  } = props;

  const { t } = useTranslation(["folders"]);

  const selectedCards = useSelector((state) => state.folders.selectedCards);
  const isPanelShowing = useSelector((state) => state.folders.isPanelShowing);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showMoveToFolderModal, setShowMoveToFolderModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showNewFolderModal, setShowNewFolderModal] = useState(false);
  const [inProgress, setInProgress] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {}, []);

  const confirmationModalDisplayType = displayType ? displayType : type;

  function handleDeleteSelectedItems() {
    setInProgress(true);

    onDeleteSelected().then(() => {
      dispatch(resetCardsSelection());
      setInProgress(false);
      setShowDeleteModal(false);
    });
  }

  useEffect(() => {}, []);

  function handleMoveToFolder(folderId, folderName) {
    setInProgress(true);

    onMoveToFolder(folderId, folderName).then(() => {
      dispatch(resetCardsSelection());
      setInProgress(false);
      setShowMoveToFolderModal(false);
      setShowNewFolderModal(false);
    });
  }

  function handleNewFolderAndMove(folderName) {
    setInProgress(true);

    dispatch(
      createNewFolder(folderName, signal.token, {
        ...props,
      })
    )
      .then((folder) => {
        setInProgress(false);
        setShowNewFolderModal(false);

        handleMoveToFolder(folder.id, folder.name);
      })
      .catch(() => {
        setInProgress(false);
        setShowNewFolderModal(false);
      });
  }

  function handleRemoveFromFolder() {
    setInProgress(true);

    onRemoveFromFolder().then(() => {
      dispatch(resetCardsSelection());
      setInProgress(false);
      setShowConfirmationModal(false);
    });
  }

  function handleResetCardsSelection() {
    dispatch(resetCardsSelection());
  }

  return (
    <>
      <HomeSelectionRow
        marginTop={marginTop}
        className={`${classes ? classes : ""}`}
        marginBottom={marginBottom}
      >
        <span className="count">{selectedCards.length} selected</span>

        <div className="action-items">
          <TldrCheckbox
            checked
            onCheck={handleResetCardsSelection}
            description="Unselect all"
          />

          <Tooltip placement="bottom" hasArrow label="Delete selected">
            <span>
              <Icon
                as={FaTrash}
                color="gray.100"
                mr={5}
                onClick={() => setShowDeleteModal(true)}
                cursor="pointer"
              />
            </span>
          </Tooltip>
          <Tooltip placement="bottom" hasArrow label="Move to Folder">
            <span>
              <Icon
                as={FaArrowAltCircleUp}
                color="gray.100"
                onClick={() => setShowMoveToFolderModal(true)}
                mr={5}
                cursor="pointer"
              />
            </span>
          </Tooltip>

          {removeFromFolder ? (
            <Tooltip label={t("move_back.action")}>
              <span>
                <Icon
                  as={FaArrowAltCircleDown}
                  color="gray.100"
                  onClick={() => setShowConfirmationModal(true)}
                  cursor="pointer"
                />
              </span>
            </Tooltip>
          ) : null}
        </div>
      </HomeSelectionRow>

      {showDeleteModal ? (
        <TldrConfirmationModal
          inProgress={inProgress}
          show={showDeleteModal}
          customMessage={`Are you sure you want to delete ${
            selectedCards.length
          } ${
            selectedCards.length > 1
              ? displayNamePluralForm
                ? displayNamePluralForm
                : confirmationModalDisplayType + "s"
              : confirmationModalDisplayType
          }?`}
          onHide={() => setShowDeleteModal(false)}
          onYes={handleDeleteSelectedItems}
        />
      ) : null}

      {showMoveToFolderModal ? (
        <TldrMoveToFolderModal
          inProgress={inProgress}
          show={showMoveToFolderModal}
          onHide={() => setShowMoveToFolderModal(false)}
          onYes={(folderId, folderName) =>
            handleMoveToFolder(folderId, folderName)
          }
          onAddFolder={() => {
            setShowMoveToFolderModal(false);
            setShowNewFolderModal(true);
          }}
          currentFolderId={currentFolderId}
        />
      ) : null}

      {showNewFolderModal ? (
        <TldrNewFolderDialog
          inProgress={inProgress}
          show={showNewFolderModal}
          onHide={() => setShowNewFolderModal(false)}
          onYes={(name) => handleNewFolderAndMove(name)}
        />
      ) : null}

      {showConfirmationModal ? (
        <TldrConfirmationModal
          inProgress={inProgress}
          show={showConfirmationModal}
          customMessage={t("move_back.heading")}
          customBodyMessage={t("move_back.message", {
            quantity: selectedCards.length,
            name:
              selectedCards.length > 1
                ? displayNamePluralForm
                  ? displayNamePluralForm
                  : confirmationModalDisplayType + "s"
                : confirmationModalDisplayType,
          })}
          customPrimaryActionText={t("move_back_button.text")}
          onHide={() => setShowConfirmationModal(false)}
          onYes={handleRemoveFromFolder}
        />
      ) : null}
    </>
  );
};

TldrSelectedCardsRow.defaultProps = {
  onMoveToFolder: () => {},
  onDeleteSelected: () => {},
  onRemoveFromFolder: () => {},
  removeFromFolder: false,
  currentFolderId: "",
  marginTop: "0",
};

export default TldrSelectedCardsRow;
